import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppDataService } from '../app-data.service';

@Injectable({
  providedIn: 'root'
})
export class RewardTypeService {

  constructor(private http: HttpClient, private globalData: AppDataService) { }

  setParams(params: any): any {
    const paramsToSend: any = {};
    paramsToSend.params = params;
    return paramsToSend;
  }

  getRewardTypes(params?: any): any {
    if(params){
      return this.http.get<any>(this.globalData.baseUrl + 'reward-types/datatable', this.setParams(params));
    }
    return this.http.get<any>(this.globalData.baseUrl + 'reward-types/datatable');
  }

  reverseTransaction(id: number, data: any): any {
    return this.http.get<any>(this.globalData.baseUrl + 'reward-types/datatable');
  }

  getRewardType(id: number): any {
    return this.http.get<any>(this.globalData.baseUrl + 'reward-types/' + id);
  }

  deleteRewardType(id: number): any {
    return this.http.delete<any>(this.globalData.baseUrl + 'reward-types/' + id);
  }

  createOdUpdateRewardType(id: number, data: any): any {
    if(id){
      return this.http.put<any>(this.globalData.baseUrl + 'reward-types/' + id, data);
    }
    return this.http.post<any>(this.globalData.baseUrl + 'reward-types/', data);
  }

  getRewardTypeForParty(partyId: number): any {
    return this.http.get(this.globalData.baseUrl  + 'reward-types/' + partyId + '/party');
  }
}
